// Course, Instructor, and Project data

export const courses = [
  {
    title: "Programming Fundamentals",
    image: "https://miro.medium.com/v2/resize:fit:1400/1*E9jq3Wm_OSoPk5u4xNzKlg.jpeg",
    description: "Learn C, Python, Java, R, and Rumi to build solid programming skills.",
    level: "Beginner",
    price: "Free",
    rating: "4.8",
    reviews: "550",
    students: "2,300",
    duration: "6 weeks",
    lessons: "20"
  },
  {
    title: "Web Development",
    image: "https://www.nexel.in/media/blog_images/web_development_Z62jy4k.jpg",
    description: "Master HTML, CSS, JavaScript for front-end and PHP, MySQL for back-end.",
    level: "Intermediate",
    price: "₹999",
    rating: "4.7",
    reviews: "600",
    students: "3,000",
    duration: "8 weeks",
    lessons: "30"
  },
  {
    title: "AI & Machine Learning",
    image: "https://aitsrajampet.ac.in/images/pdf/ai/Artificial-Intelligence-and-Machine-Learning.png",
    description: "Explore AI and ML using Python, real projects, and expert mentoring.",
    level: "Advanced",
    price: "₹1,499",
    rating: "4.9",
    reviews: "700",
    students: "4,500",
    duration: "10 weeks",
    lessons: "40"
  },
  {
    title: "React + Node.js",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSVE0QhjaKnNwj28xJCElxlDSXYvmPEAZaC0A&s",
    description: "Build dynamic full-stack apps with React for frontend and Node.js backend.",
    level: "Intermediate",
    price: "₹1,299",
    rating: "4.8",
    reviews: "480",
    students: "2,700",
    duration: "8 weeks",
    lessons: "28"
  },
  {
    title: "Power BI & Analytics",
    image: "https://lh7-us.googleusercontent.com/STLKRZRCto2iMCafWVYZ2y4az9kdS03daX-5dQVXhON--dG8kbsQKuMfscVpX7lh_JbIgi4CoZfdT8eLDoPUzcvI-V0fe-VSDZpjHEI-KZMMroYlo6iCaasdE00gKybcJkUw7gOLc3VRANj_GvO4Hxc",
    description: "Visualize data and create interactive dashboards using Power BI.",
    level: "Beginner",
    price: "₹999",
    rating: "4.6",
    reviews: "300",
    students: "1,500",
    duration: "4 weeks",
    lessons: "15"
  },
  {
    title: "Reasoning + Aptitude",
    image: "https://coignite.instacks.co/uploads/learning_path/lz3muy3x.png",
    description: "Sharpen your reasoning, logic, and aptitude for competitive exams.",
    level: "Beginner",
    price: "₹499",
    rating: "4.5",
    reviews: "250",
    students: "1,200",
    duration: "3 weeks",
    lessons: "12"
  }
];

export const instructors = [
  {
    name: "Sofikul Mallick",
    title: "AI/ML Engineer",
    image: "https://t3.ftcdn.net/jpg/08/12/63/16/360_F_812631683_ek5GhlY2zdlSILJMT7pHFujzi37i4Os4.jpg",
    bio: "M.Tech from Jadavpur University, expert in Machine Learning and Artificial Intelligence.",
    rating: "4.9",
    students: "9,800",
    courses: "6",
    skills: ["Python", "AI", "ML", "Deep Learning"]
  },
  {
    name: "Nilmoni Pal",
    title: "Electronics & Communication Engineer",
    image: "https://t3.ftcdn.net/jpg/08/12/63/16/360_F_812631683_ek5GhlY2zdlSILJMT7pHFujzi37i4Os4.jpg",
    bio: "B.Tech in ECE, passionate about embedded systems, networks, and communication.",
    rating: "4.7",
    students: "6,500",
    courses: "4",
    skills: ["Networking", "IoT", "Python", "Communication"]
  },
  {
    name: "Md Mainuddin",
    title: "Software Engineer",
    image: "https://t3.ftcdn.net/jpg/08/12/63/16/360_F_812631683_ek5GhlY2zdlSILJMT7pHFujzi37i4Os4.jpg",
    bio: "MCA from Jadavpur University, proficient in web and backend development.",
    rating: "4.8",
    students: "8,200",
    courses: "5",
    skills: ["Java", "Spring Boot", "PHP", "MySQL"]
  }
];

export const projects = [
  {
    title: "E-commerce Platform",
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=400&h=300&fit=crop",
    description: "Build a complete e-commerce platform with payment integration and admin dashboard.",
    difficulty: "Advanced",
    duration: "6 weeks",
    technologies: ["React", "Node.js", "MongoDB", "Stripe"]
  },
  {
    title: "Weather Forecast App",
    image: "https://images.unsplash.com/photo-1504608524841-42fe6f032b4b?w=400&h=300&fit=crop",
    description: "Create a responsive weather app with real-time data and location services.",
    difficulty: "Beginner",
    duration: "2 weeks",
    technologies: ["HTML", "CSS", "JavaScript", "API"]
  },
  {
    title: "Social Media Dashboard",
    image: "https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=400&h=300&fit=crop",
    description: "Design an analytics dashboard for social media management with charts and insights.",
    difficulty: "Intermediate",
    duration: "4 weeks",
    technologies: ["React", "Chart.js", "Firebase", "CSS"]
  }
];
